import { StripePaymentRequestButtonElementOptions } from '@stripe/stripe-js';
import getCurrencyValue from '../../../../../../../../../utils/scripts/getCurrencyValue';
import getCountryByCurrency from '../../../../../../../../../utils/scripts/getCountryByCurrency';

export const options = (paymentRequest: any): StripePaymentRequestButtonElementOptions => ({
  paymentRequest,
  style: {
    paymentRequestButton: {
      height: '55px',
    },
  },
});

export const paymentRequestOptions = (label: string, amount: number) => {
  const currency = getCurrencyValue()?.toLowerCase() || 'usd';

  return {
    country: getCountryByCurrency(currency),
    currency,
    total: {
      label,
      amount,
    },
    requestPayerName: true,
    requestPayerEmail: true,
  };
};

